/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelListOfAllocationGet$Params {
  officeId?: string;
}

export function apiExcelExcelListOfAllocationGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelListOfAllocationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelListOfAllocationGet.PATH, 'get');
  if (params) {
    rb.query('officeId', params.officeId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelListOfAllocationGet.PATH = '/api/Excel/Excel_ListOfAllocation';
